// Clickini's - header over the hero. The announcement bar scrolls away; the header follows it up until it reaches the top,
// turns solid after a short scroll, and returns to transparent at the top of the home hero.
(function () {
  var root = document.documentElement;
  var ann = function () { return document.querySelector('.ck-announcement'); };
  var annH = 0;
  function measure() { var a = ann(); annH = a ? a.offsetHeight : 0; root.style.setProperty('--ck-ann-h', annH + 'px'); update(); }
  function update() {
    var y = window.scrollY || 0;
    root.style.setProperty('--ck-header-top', Math.max(0, annH - y) + 'px');
    root.classList.toggle('ck-scrolled', y > annH + 24);
  }
  measure();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
})();
